import * as Yup from "yup";
import { formFieldRex, fieldErrorMessage } from "../../GenericForm/Components/FunctionLib";
import { ACTMembershipFormConstants } from "./constants";

const errorMsg = {
	required: "This field is required",
	email: "This field must be a valid email address",
	phone: "This field must be a valid phone number",
	postcode: "This field must be a valid postcode",
	noNumAllowed: "No numbers allowed",
	date: "This field must be a valid date",
};

export const ACTMembershipValidationSchema = Yup.object().shape({
	[ACTMembershipFormConstants.firstName]: Yup.string()
		.required(errorMsg.required)
		.matches(formFieldRex.nameRegExp, fieldErrorMessage.nameFieldError)
		.max(40),
	[ACTMembershipFormConstants.lastName]: Yup.string()
		.required(errorMsg.required)
		.matches(formFieldRex.nameRegExp, fieldErrorMessage.nameFieldError)
		.max(40),
	[ACTMembershipFormConstants.dateOfBirth]: Yup.string()
		.required(errorMsg.required)
		.matches(formFieldRex.dateRegExp, errorMsg.date),
	[ACTMembershipFormConstants.email]: Yup.string()
		.required(errorMsg.required)
		.email(errorMsg.email)
		.max(50),
	[ACTMembershipFormConstants.address1]: Yup.string().required(errorMsg.required),
	[ACTMembershipFormConstants.sameAsResidential]: Yup.string().required(errorMsg.required),
	[ACTMembershipFormConstants.gender]: Yup.string().required(errorMsg.required),
	[ACTMembershipFormConstants.aboriginalDescent]: Yup.string().required(errorMsg.required),
	[ACTMembershipFormConstants.category]: Yup.string().required(errorMsg.required),
	[ACTMembershipFormConstants.occupation]: Yup.string().required(errorMsg.required).max(50),
	[ACTMembershipFormConstants.isUnionMember]: Yup.string().required(errorMsg.required),
	[ACTMembershipFormConstants.declareContactShared]: Yup.bool()
		.oneOf([true], errorMsg.required)
		.required(errorMsg.required),
	[ACTMembershipFormConstants.declareNotPoliticalMember]: Yup.bool()
		.oneOf([true], errorMsg.required)
		.required(errorMsg.required),
	[ACTMembershipFormConstants.declareJoinAlp]: Yup.bool()
		.oneOf([true], errorMsg.required)
		.required(errorMsg.required),
	[ACTMembershipFormConstants.declarePayAlp]: Yup.bool()
		.oneOf([true], errorMsg.required)
		.required(errorMsg.required),

	//only required if union is selected
	[ACTMembershipFormConstants.unionMemberOf]: Yup.string()
		.notRequired()
		.when([ACTMembershipFormConstants.isUnionMember], {
			is: (a) => a === "yes",
			then: Yup.string().required(errorMsg.required),
		}),

	//only required if union is selected
	[ACTMembershipFormConstants.transferringFrom]: Yup.string()
		.notRequired()
		.when([ACTMembershipFormConstants.transferring], {
			is: (a) => a === "yes",
			then: Yup.string().required(errorMsg.required),
		}),

	// validate non required values
	[ACTMembershipFormConstants.mobile]: Yup.string()
		.matches(formFieldRex.phoneRegExp, errorMsg.phone)
		.max(50),
	[ACTMembershipFormConstants.phoneHome]: Yup.string()
		.matches(formFieldRex.phoneRegExp, errorMsg.phone)
		.max(50),
	[ACTMembershipFormConstants.phoneBusiness]: Yup.string()
		.matches(formFieldRex.phoneRegExp, errorMsg.phone)
		.max(50),
	[ACTMembershipFormConstants.postcode]: Yup.string()
		.matches(formFieldRex.postcodeRegExp, errorMsg.postcode)
		.max(4),

	// if union selected make unionmember of required
});
